import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import axios from "axios";
import CommonModal from "./CommonModal";
import { Formik, Form, Field } from "formik";
import { FileUploader } from "react-drag-drop-files";
import {
  MdKeyboardBackspace,
  MdCloudUpload,
  MdCloudDownload,
  MdAddBox,
} from "react-icons/md";
import { useUser } from "../Commonfunction/UserContext";
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import PermissionMessage from "./PermissionMessage";
import { checkPermission } from "../Commonfunction/NewPermission";

const TopHeading = ({
  heading,
  buttonName,
  path,
  setShowModal,
  isHideBtn,
  csvFileUpload,
  csvName,
  csvExportName,
  fetchData,
  isLoading = false,
  isBackArrow = false,
  businessTypeData,
}) => {
  const [importModal, setImportModal] = useState(false);
  const [importCustomerModal, setImportCustomerModal] = useState(false);
  const [selectBusinessType, setSelectBusinessType] = useState("");
  const [isSingleFile, setIsSingleFile] = useState(false);
  const handleClose = () => {
    setImportModal(false);
    setSelectBusinessType("");
  };
  const handleCloseCustomer = () => {
    setImportCustomerModal(false);
    setSelectBusinessType("");
    setFile(null);
  };
  // console.log('businessTypeData', businessTypeData)
  const businessType = [
    {
      label: "Retail - Convenience Store - Gas",
      value: "Retail - Convenience Store - Gas",
    },
    {
      label: "Retail - Liquor Store",
      value: "Retail - Liquor Store",
    },
    {
      label: "Retail - Fast Food Restaurant",
      value: "Retail - Fast Food Restaurant",
    },
    {
      label: "Hotel - Motel",
      value: "Hotel - Motel",
    },
  ];
  const token = localStorage.getItem("token");
  const cpc_db_connect = localStorage.getItem("cpc_db");
  const handleSubmitFile = (values, request_url) => {
    // console.log('values', values)
    axios
      .post(
        // "/api/save-settings", values,
        request_url,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "X-CPC-Connect": cpc_db_connect,
          },
        }
      )
      .then(
        (response) => {
          if (response.data.success) {
            toast.success(response.data.message);
            setImportCustomerModal(false);
            setSelectBusinessType("");
            setFile(null);
            fetchData();
          } else {
            toast.error(response.data.message);
          }
        },
        (error) => {
          if (error.response.status === 401) {
            toast.error(error.response.data.message);
          }
          return error;
        }
      );
  };

  const navigate = useNavigate();
  const { setUserAccess, role } = useUser();
  const userType = localStorage.getItem("user_type");
  const [permissionMassage, setPermissionMassage] = useState(false);
  const fetchDataUserAccess = async (method, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        checkPermission(role, method, result.permission)
          ? navigate(goToLink)
          : setPermissionMassage(true);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };

  const fileTypes = ["csv"];
  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
  };

  const handleFileChange = async (event, url) => {
    // const selectedFile = event.target.files[ 0 ];
    const selectedFile = event;
    if (selectedFile && selectedFile.type === "text/csv") {
      setFile(selectedFile);

      const formData = new FormData();
      formData.append(url == "importCsv" ? "file" : "file1", selectedFile);
      !isSingleFile && formData.append("business_type", selectBusinessType);
      try {
        const request_url = `/api/${url}`;
        const postDataResult = await handleSubmitFile(formData, request_url);
        if (postDataResult?.success) {
          toast.success(postDataResult?.message);
        } else {
          toast.error(postDataResult?.message);
        }
      } catch (error) {
        // Handle error
        console.log("Error: ", error);
      }
    } else {
      alert("Please upload a valid CSV file.");
    }
  };
  const handleFileChangeExcel = async (url) => {
    // console.log('handleFileChangeExcel', url)
    const formData = new FormData();
    formData.append("business_type", selectBusinessType);
    try {
      const request_url = `/api/${url}`;
      const postDataResult = await postData(request_url, formData);
      if (postDataResult) {
        // toast.success(postDataResult?.message);
        delete postDataResult["permission"];
        delete postDataResult["financial_year"];
        delete postDataResult["financial_year_cutoff_date"];
        delete postDataResult["latest_financial_year"];
        // const keysArray = Object.keys(postDataResult);
        // const combinedArray = Object.values(postDataResult).flat();
        // console.log('postDataResult', postDataResult)
        const keysArray = Object.entries(postDataResult)?.flatMap(
          ([key, values]) => values?.map(() => key)
        );
        // console.log('postDataResult1', keysArray)

        const combinedArray = Object.entries(postDataResult)?.flatMap(
          ([key, values]) => values
        );
        // console.log('postDataResult2', combinedArray)

        const keysArrayWithUnderscores = keysArray.map((item) =>
          item.replace(/ /g, "_")
        );
        // console.log('postDataResult3', keysArrayWithUnderscores)

        const combinedArrayWithUnderscores = combinedArray?.map((item) =>
          item.replace(/ /g, "_")
        );
        // console.log('postDataResult4', combinedArrayWithUnderscores)

        handleDownload(
          keysArrayWithUnderscores,
          combinedArrayWithUnderscores,
          selectBusinessType
        );
        setSelectBusinessType("");
        setImportModal(false);
      } else {
        toast.error(postDataResult?.message);
      }
    } catch (error) {
      // Handle error
      console.log("Error: ", error);
    }
  };

  const handleDownload = (keysArray, datas, name, customerDownload = false) => {
    // sample Data for the CSV
    const customer_sample = [
      [
        "company_name",
        "dba_name",
        "client_since",
        "date_est",
        "client_owner",
        "external_id",
        "email",
        "business_type",
        "company_type",
        "s_and_u_number",
        "ein_number",
        "company_occupation_no",
        "hm_fee",
        "industry",
        "customer_name",
        "mobile_no",
        "landline_no",
        "state",
        "zip_code",
        "city",
      ],
      [
        "xyz",
        "",
        "",
        "",
        "",
        "",
        "email@email.com",
        "",
        "",
        "1231",
        "12",
        "",
        "",
        "",
        "",
        "7894561236",
        "",
        "GA",
        "",
        "",
      ],
    ];

    const data = customerDownload
      ? customer_sample
      : [
          [name, "", "", "", ...keysArray],
          ["client_name", "year", "month", "tax", ...datas],
        ];
    // console.log('postDataResult5', data)
    // Convert data to CSV format
    const csvContent =
      "data:text/csv;charset=utf-8," +
      // data.join("\n"); // Join the array elements with a newline character
      data?.map((row) => row.join(",")).join("\n");

    // Create a link element
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");

    // Set attributes for the link
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${name}.csv`);

    // Append to the document and trigger download
    document.body.appendChild(link);
    link.click();

    // Remove the link after download
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="grid-row padding-1">
        {isBackArrow && (
          <div
            className="back-button"
            onClick={() =>
              heading === "Customer Files"
                ? navigate("/Client")
                : navigate(-1)
            }
          >
            <MdKeyboardBackspace size={22} />
          </div>
        )}

        <div className="grid-col-6">
          <h2
            className="margin-top-2 text-semibold"
            style={{ marginLeft: isBackArrow ? "8px" : "0px", color: "#2c7be5" }}
          >
            {heading }
          </h2>
        </div>

        <div className="grid-col-6 text-right">
          {csvFileUpload && (
            <>
              <button
                disabled={isLoading}
                className="usa-button"
                type="button"
                onClick={() => {
                  setImportCustomerModal(true);
                  setIsSingleFile(true);
                }}
              >
                <MdCloudUpload size={18} /> &nbsp; {csvName}
              </button>

              <button
                disabled={isLoading}
                className="usa-button"
                type="button"
                onClick={() => {
                  setImportCustomerModal(true);
                  setIsSingleFile(false);
                }}
              >
                <MdCloudUpload size={18} /> &nbsp; {csvExportName}
              </button>
            </>
          )}

          {isHideBtn && (
            <button
              className="btn btn-submit"
              type="button"
              onClick={() =>
                path
                  ? userType === "Admin"
                    ? navigate(path)
                    : fetchDataUserAccess("add", path)
                  : setShowModal(true)
              }
            >
              <MdAddBox size={18} /> &nbsp; {heading || "Add New"}
            </button>
          )}
        </div>
      </div>

      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => setPermissionMassage(false)}
        />
      )}

      {importModal && (
        <CommonModal
          open={importModal}
          onClose={handleClose}
          title="Sample File Import"
        >
          <div className="margin-y-2">
            <Formik initialValues={{ business_type: "" }} onSubmit={() => {}}>
              {() => (
                <Form>
                  <label
                    htmlFor="business_type"
                    className="margin-bottom-1 text-bold"
                  >
                    Business Type
                  </label>
                  <Field
                    name="business_type"
                    component={CustomSelect}
                    options={businessTypeData}
                    onChange={(event) => setSelectBusinessType(event?.value)}
                  />
                </Form>
              )}
            </Formik>
          </div>

          <div className="margin-top-2 text-right">
            <button
              className="usa-button usa-button--unstyled margin-right-2"
              type="button"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="usa-button"
              type="button"
              disabled={!selectBusinessType}
              onClick={() => handleFileChangeExcel("getTaxHead")}
            >
              <MdCloudDownload size={18} /> &nbsp; Download
            </button>
          </div>
        </CommonModal>
      )}

      {importCustomerModal && (
        <CommonModal
          open={importCustomerModal}
          onClose={handleCloseCustomer}
          title={
            isSingleFile
              ? "Customer Import"
              : "Import Customer Files / Download Sample File"
          }
          size="add_large"
        >
          <Formik initialValues={{ business_type: "" }} onSubmit={() => {}}>
            {() => (
              <Form>
                {!isSingleFile && (
                  <>
                    <label
                      htmlFor="business_type"
                      className="margin-bottom-1 text-bold"
                    >
                      Business Type
                    </label>
                    <Field
                      name="business_type"
                      component={CustomSelect}
                      options={businessTypeData}
                      onChange={(event) => setSelectBusinessType(event?.value)}
                    />
                  </>
                )}

                <label htmlFor="file" className="margin-top-2 text-bold">
                  File
                </label>
                <div className="width-full">
                  <FileUploader handleChange={handleChange} name="file" />
                </div>

                <div className="margin-top-3 text-right">
                  <button
                    className="usa-button usa-button--unstyled margin-right-2"
                    type="button"
                    onClick={handleCloseCustomer}
                  >
                    Close
                  </button>
                  <button
                    disabled={
                      isSingleFile
                        ? isLoading || !file
                        : isLoading || !selectBusinessType || !file
                    }
                    className="usa-button"
                    type="button"
                    onClick={() =>
                      isSingleFile
                        ? handleFileChange(file, "importCsv")
                        : handleFileChange(file, "ImportcustomerFiles")
                    }
                  >
                    <MdCloudUpload size={18} /> &nbsp;{" "}
                    {isSingleFile ? csvName : csvExportName}
                  </button>

                  <button
                    className="usa-button margin-left-2"
                    type="button"
                    disabled={isSingleFile ? false : !selectBusinessType}
                    onClick={() =>
                      isSingleFile
                        ? handleDownload(null, null, "customer sample", true)
                        : handleFileChangeExcel("getTaxHead")
                    }
                  >
                    <MdCloudDownload size={18} /> &nbsp; Download
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </CommonModal>
      )}
    </>
  );
};

export default TopHeading;
